const theme = {
  colors: {
    background: "#F2F2F2",
    text: "#121212",
    primary: "#8257e6",
  },
};

export default theme;
